module.exports = __webpack_public_path__ + "media/images/new/icons/pretty_checkbox-check-84a96269a4569ef8b71c0b663066a602.png";